$(document).ready(function() {
	$('ul#grid-items.special li:gt(3):nth-child(3n+1)').css('margin-right', '0');

	/*$('ul#grid-items li').each(function(index){
		$('article div.excerpt img:first', this).clone().prependTo(this);
		$('article div.excerpt img:first', this).remove();
	});*/
});